import { render, staticRenderFns } from "./dialog-detaildelete.vue?vue&type=template&id=838f6630&"
import script from "./dialog-detaildelete.vue?vue&type=script&lang=js&"
export * from "./dialog-detaildelete.vue?vue&type=script&lang=js&"
import style0 from "./dialog-detaildelete.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports